import React from 'react';
import { MediaElement, MediaElementModel, ModuleBase } from '@/components';
import classNames from 'classnames';
import InfoSection, { InfoSectionModel } from './InfoSection/InfoSection';
import { ModuleBaseModel, ModuleBaseNameProps, ModuleBasePropsModel } from '@/types';

export type InfoBlockModuleModel = ModuleBaseModel<
  {
    imageOrientation?: 'Portrait' | 'Landscape' | 'Square';
    alignment?: 'Left' | 'Right';
    infoSection: InfoSectionModel<ModuleBaseNameProps>;
    infoSectionVerticalAlignment?: 'Top' | 'Center' | 'Bottom';
    mediaSection: MediaElementModel;
    mediaSectionComponent?: React.ReactNode;
  } & ModuleBasePropsModel
>;

const InfoBlockModule = (data: InfoBlockModuleModel) => {
  const { props } = data;

  let widths = { xs: 335, sm: 331, md: 331, lg: 331, xl: 331 };
  let heights = { xs: 447, sm: 441, md: 441, lg: 441, xl: 441 };
  let aspect = 'aspect-[335/447] sm:aspect-[331/441]';

  if (props.imageOrientation?.toLowerCase() === 'landscape') {
    widths = { xs: 407, sm: 401, md: 401, lg: 401, xl: 401 };
    heights = { xs: 250, sm: 230, md: 230, lg: 230, xl: 230 };
    aspect = 'aspect-[407/250] sm:aspect-[401/230]';
  } else if (props.imageOrientation?.toLowerCase() === 'square') {
    widths = { xs: 335, sm: 331, md: 331, lg: 331, xl: 331 };
    heights = { xs: 335, sm: 331, md: 331, lg: 331, xl: 331 };
    aspect = 'aspect-square';
  }

  const isHalfWidth = ['EmbeddedMediaElement', 'PodcastElement', 'LinksBlock'].includes(props.mediaSection.moduleName);

  return (
    <ModuleBase
      data={data}
      className={classNames(
        'relative overflow-hidden',
        props.noPaddingOnTop && 'pt-3',
        props.noPaddingOnBottom && 'pb-3',
      )}
    >
      <div
        className={classNames(
          'container flex justify-between gap-5 lg:gap-10',
          props.alignment === 'Right' ? 'flex-col-reverse lg:flex-row-reverse' : 'flex-col lg:flex-row',
        )}
      >
        <div className={classNames('w-full', isHalfWidth ? 'lg:w-1/2' : 'lg:w-1/3')}>
          {data.props.mediaSectionComponent
            ? data.props.mediaSectionComponent
            : props.mediaSection && (
                <MediaElement
                  className="mx-auto flex w-full flex-col justify-center print:w-full"
                  {...props.mediaSection}
                  imageElementProps={{ className: aspect, widths, heights }}
                  alignment={props.alignment}
                  backgroundColor={props.backgroundColour}
                />
              )}
        </div>
        <div
          className={classNames(
            'flex w-full',
            isHalfWidth ? 'lg:w-1/2' : 'lg:w-7/12',
            props.infoSectionVerticalAlignment === 'Top'
              ? 'items-start'
              : props.infoSectionVerticalAlignment === 'Bottom'
                ? 'items-end'
                : 'items-center',
          )}
        >
          {props.infoSection && <InfoSection {...props.infoSection} />}
        </div>
      </div>
    </ModuleBase>
  );
};

export default InfoBlockModule;
